import script from "./CardPaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./CardPaymentForm.vue?vue&type=style&index=0&id=310eb964&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310eb964"]])

export default __exports__